<template>
  <div class="s-audioLine">
    <div class="active" :style="{'width':audioPercent+'%'}"></div>
  </div>
</template>

<script>
import { mapState,mapGetters,mapMutations } from 'vuex';
export default {
  name: 'sAudioLine',
  props: { },
  data(){
    return{
    }
  },
  computed:{
    ...mapGetters("audio", {
      audioPercent: "getPercent",
    }),
  },
  methods:{

  },
}
</script>
<style scoped lang="scss">
  .s-audioLine{
    width: 100%;
    height: 4rem;
    background: #fff;
    .active{
      height: 100%;
      background: var(--mainColor);
      border-radius: 4rem;
      // transition: all 0.1s;
    }
  }

</style>